
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/wheels/pickup/nissan-navara",
      function () {
        return require("private-next-pages/wheels/pickup/nissan-navara.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/wheels/pickup/nissan-navara"])
      });
    }
  